// ⚠️ AUTO-GENERATED — DO NOT EDIT MANUALLY
// Source: ./svg/IconTable.svg — regenerate with `nx run creditflowresearch-uilib:icons-generate --write`
import BaseIcon from './BaseIcon';
import type { IIconProps } from './types';

const IconTable = (props: IIconProps) => (
  <BaseIcon viewBox="0 0 16 16" fill="currentColor" { ...props }>
    <path fillRule="evenodd" clipRule="evenodd" d="M1 0H15C15.5522 0 16 0.447821 16 1V15C16 15.5522 15.5522 16 15 16H1C0.447821 16 0 15.5522 0 15V1C0 0.447821 0.447821 0 1 0ZM5 15V12H1V15H5ZM6 12V15H10.0024V12L6 12ZM11.0024 12V15H15V12L11.0024 12ZM14.9928 11.0096H11.0024V8H15V11H14.9928V11.0096ZM10.0024 11.0096L6 11.0096V8H10.0024V11.0096ZM11.0024 7V4H15L15 7H11.0024ZM10 5.72131L10.0024 5.72069V7H6V4H10V5.72131ZM5 4H1V7H5V4ZM5 8H1V11H5V8Z" />
  </BaseIcon>
);

export default IconTable;
